// FETCH ALL PRINTING2 INWARD
export const FETCH_PRINTING2_INWARD_MASTER_REQUEST_DK = 'FETCH_PRINTING2_INWARD_MASTER_REQUEST_DK';
export const FETCH_PRINTING2_INWARD_MASTER_SUCCESS_DK = 'FETCH_PRINTING2_INWARD_MASTER_SUCCESS_DK';
export const FETCH_PRINTING2_INWARD_MASTER_FAILURE_DK = 'FETCH_PRINTING2_INWARD_MASTER_FAILURE_DK';

// FETCH ALL PRINTING2 INWARD
export const FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK = 'FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK';
export const FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK = 'FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK';
export const FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK = 'FETCH_PRINTING2_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK';

// CREATE PRINTING2 INWARD
export const CREATE_PRINTING2_INWARD_MASTER_REQUEST_DK = 'CREATE_PRINTING2_INWARD_MASTER_REQUEST_DK';
export const CREATE_PRINTING2_INWARD_MASTER_SUCCESS_DK = 'CREATE_PRINTING2_INWARD_MASTER_SUCCESS_DK';
export const CREATE_PRINTING2_INWARD_MASTER_FAILURE_DK = 'CREATE_PRINTING2_INWARD_MASTER_FAILURE_DK';

// CREATE PRINTING2 INWARD
export const CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_REQUEST_DK = 'CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_REQUEST_DK';
export const CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_SUCCESS_DK = 'CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_SUCCESS_DK';
export const CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_FAILURE_DK = 'CREATE_PRINTING2_INWARD_EDIT_QTY_MASTER_FAILURE_DK';

// UPDATE PRINTING2 INWARD
export const UPDATE_PRINTING2_INWARD_MASTER_REQUEST_DK = 'UPDATE_PRINTING2_INWARD_MASTER_REQUEST_DK';
export const UPDATE_PRINTING2_INWARD_MASTER_SUCCESS_DK = 'UPDATE_PRINTING2_INWARD_MASTER_SUCCESS_DK';
export const UPDATE_PRINTING2_INWARD_MASTER_FAILURE_DK = 'UPDATE_PRINTING2_INWARD_MASTER_FAILURE_DK';

// FETCH SINGLE STATE OF PRINTING2 INWARD
export const FETCH_SINGLE_PRINTING2_INWARD_MASTER_REQUEST_DK = 'FETCH_SINGLE_PRINTING2_INWARD_MASTER_REQUEST_DK';
export const FETCH_SINGLE_PRINTING2_INWARD_MASTER_SUCCESS_DK = 'FETCH_SINGLE_PRINTING2_INWARD_MASTER_SUCCESS_DK';
export const FETCH_SINGLE_PRINTING2_INWARD_MASTER_FAILURE_DK = 'FETCH_SINGLE_PRINTING2_INWARD_MASTER_FAILURE_DK';

// DELETE PRINTING2 INWARD
export const DELETE_PRINTING2_INWARD_MASTER_REQUEST_DK = 'DELETE_PRINTING2_INWARD_MASTER_REQUEST_DK';
export const DELETE_PRINTING2_INWARD_MASTER_SUCCESS_DK = 'DELETE_PRINTING2_INWARD_MASTER_SUCCESS_DK';
export const DELETE_PRINTING2_INWARD_MASTER_FAILURE_DK = 'DELETE_PRINTING2_INWARD_MASTER_FAILURE_DK';

export const FETCH_PENDING_PRINTING2_PO_IN_INWARD_REQUEST_DK = 'FETCH_PENDING_PRINTING2_PO_IN_INWARD_REQUEST_DK';
export const FETCH_PENDING_PRINTING2_PO_IN_INWARD_SUCCESS_DK = 'FETCH_PENDING_PRINTING2_PO_IN_INWARD_SUCCESS_DK';
export const FETCH_PENDING_PRINTING2_PO_IN_INWARD_FAILURE_DK = 'FETCH_PENDING_PRINTING2_PO_IN_INWARD_FAILURE_DK';

export const RESET_PRINTING2_INWARD_MASTER_INFO_DK = 'RESET_PRINTING2_INWARD_MASTER_INFO_DK';

export const CREATE_PRINTING2_INWARD_MASTER_FORM_DK = 'CREATE_PRINTING2_INWARD_MASTER_FORM_DK';

export const UPDATE_PRINTING2_INWARD_MASTER_FORM_DK = 'UPDATE_PRINTING2_INWARD_MASTER_FORM_DK';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_PRINTING2_INWARD_DETAILS_DK = 'NAVIGATE_PRINTING2_INWARD_DETAILS_DK';

// NAVIGATE TO PRINTING2 INWARD COMPONENT
export const NAVIGATE_PRINTING2_INWARD_MASTER_DK = 'NAVIGATE_PRINTING2_INWARD_MASTER_DK';

export const RESET_FORM_DATA_WITHOUT_PRINTING2_INWARD_ID_DK = 'RESET_FORM_DATA_WITHOUT_PRINTING2_INWARD_ID_DK';

export const RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING2_INWARD_ID_DK = 'RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_PRINTING2_INWARD_ID_DK';

export const SET_ACTIVE_KEY_PRINTING2_INWARD_DK = 'SET_ACTIVE_KEY_PRINTING2_INWARD_DK';
